import styled from '@emotion/styled';
import {colors} from 'ui/config';

export const Container = styled('div')({
  backgroundColor: colors.darkBrown,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingBottom: 140,
});
